import { createFileRoute } from '@tanstack/react-router'

import { ClientPortalPublicPage } from '@/pages/client-portal/public/page'

export interface ValidatedSearchParams {
  companyId?: number
}

export const Route = createFileRoute('/client-portal/public/$encodedCaseId')({
  validateSearch: (params): ValidatedSearchParams => {
    return {
      companyId: params.companyId ? Number(params.companyId) : undefined,
    }
  },
  component: ClientPortalPublicPage,
})
